import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Form, InputGroup, Row } from 'react-bootstrap';
import Board from '../../../../components/Trello/Board';
import CardDetails from '../../../../components/Trello/CardDetails';
import LoadingSpinner from '../../../../components/LoadinSpinner';
import TitlePage from '../../../../components/TitlePage';

import ConsultaProcessosCRM from '../../../../../lib/json/consultas/ProcessosCRM.json'
import ConsultaCategoria from '../../../../../lib/json/consultas/Categorias.json'
import ConsultaFormularioCRM from '../../../../../lib/json/consultas/FormularioCRM.json'
import { ConsultaAPI } from '../../../../../backend/ConsultaAPI';
import { useNavigate } from 'react-router-dom';
import { formatarComoMoeda, RetornaUsuarioLogado } from '../../../../contents/VariaveisGlobais';

function ListaProcessos(){
	const navigate = useNavigate()
	const [columns, setColumns] = useState(null);
    const [carregar, setCarregar] = useState(false);
    const [ categorias, setCategorias ] = useState();

	var consultaCategorias  = ConsultaCategoria.consulta;
	var usuarioLogado

	useEffect(() => {
		usuarioLogado = RetornaUsuarioLogado()
    
		loadCategorias();
    }, []);

	const loadCategorias = async() => {
		setCarregar(true);

		const filtraFunil = usuarioLogado.crmFunil.map( (item) => item.value ).join(",")
		
		if (filtraFunil){
			consultaCategorias += ` WHERE Id IN (${filtraFunil}) `
		}

		consultaCategorias += ' ORDER BY Ordem'
		
        var retConsulta = await ConsultaAPI( consultaCategorias );
        
		setCategorias(retConsulta.data);
        setCarregar(false);
	}

	const handleEtapas = async(e, CategoriaId) => {
		const colunas = [];
		
		let consultaCategorias  = ConsultaFormularioCRM.consulta + " WHERE CategoriasId = '" + CategoriaId + "' AND EtapasId IS NOT NULL";
		let retConsulta = await ConsultaAPI( consultaCategorias );

		if (retConsulta.data){
			let dados = retConsulta.data

			//Busca a Primeira Categoria para fazer a Criação da Tela
			let consultaProcessoCRM = ConsultaProcessosCRM.consulta + ` WHERE Status = 'A' AND CategoriaId = ${CategoriaId} `;
			let retProcessoCRM = await ConsultaAPI(consultaProcessoCRM);	
			let dadosProcessos = retProcessoCRM.data.map( (item) => {
				let titulo = `Id: ${item.IdOrigem}
${item.ClienteNome} - ${item.ClienteUnidade}
Contato: ${item.ClienteContato} `;

				if (item.NumeroOrcamento){
					titulo += `
Orçamento: ${item.NumeroOrcamento}`
				}
				
				if (item.Titulo){
					titulo += `
Título: ${item.Titulo}`
				}
				
				if (item.Valor){
					titulo += `
-----
Valor: ${formatarComoMoeda(item.Valor)}`
				}

				item.title = titulo;				
				item.TituloCard = titulo;

				return item
			})

			dados.forEach( (item) => {
				colunas.push({
					id: item.EtapasId,
					title: item.EtapasDescricao.replace( item.EtapasId + ' - ', ''),
					cards: dadosProcessos.filter((processos) => processos.EtapaId === item.EtapasId)
				})
			})
		}

		setColumns(colunas)
	}

    const handleCardClick = (card) => {
		navigate(`./Alterar/${card.Id}`)
    };

    // const handleCardMove = (updatedColumns) => {
    //     setColumns(updatedColumns);
    // };

    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text={"Processos CRM"}/>
            </Col>
        </Row>
		<Container>
        	<Row>
				{	categorias && categorias.map((categoria, index) => (
					<Col md={3} key={index} className="mb-4">
						<Card className="mb-3" key={categoria.Id} onClick={ e => handleEtapas(e, categoria.Id)}>
							<Card.Body>
								<Card.Title className="text-center">{categoria.Descricao}</Card.Title>
							</Card.Body>
						</Card>		
					</Col>				
						// <Col key={} md="3" xs="12">
						// 	<Button variant='light' >{categoria.Descricao}</Button>
						// </Col>
					))
				}
			</Row>
		</Container>
		{ columns && (
			<Row>
				<Col md="12" xs="12">
					<Board columns={columns} onCardClick={handleCardClick} /> {/* onCardMove={handleCardMove} /> */}
				</Col>
			</Row>
		)}
        </>
    );
};

export default ListaProcessos;
